import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { BasicForm, InputField, TextareaField, SelectField } from 'react-serial-forms';
import t from 'tcomb-form';
import { WebsiteRefinement, WebsiteTransformer, PromoCodeRefinement } from '../utils/tcomb-utils';

import { PromoCodes } from '../utils/bfwPromoCodes';

import { doSaveBFWApplication, doUpdateBFWApplication } from  '../actions';
import { UserIsAuthenticated, UserIsVerified } from '../utils/auth';
import { EmailRefinement } from '../utils/tcomb-utils';
import DocumentMeta from 'react-document-meta';
import PaypalButton from '../components/PaypalButton';
import settings from '../settings';
import { loadCollageOrganizations } from '../actions';
import HomeCollage from '../components/HomeCollage';
import { Link } from 'react-router';
import { pushState } from 'redux-router';

const CLIENT = {
  sandbox: settings.paypalclient.PAYPAL_CLIENT_ID_SANDBOX,
  production: settings.paypalclient.PAYPAL_CLIENT_ID_PRODUCTION,
};



const ENV = settings.paypalenv.env === 'production'
  ? 'production'
  : 'sandbox';

const IsWomenOwned = t.enums({
  yes: "Yes",
  no: "No"
});

const MembershipLevel = t.enums({
  BA: "Basic:   $120.00/yr",
  PR: "Premium: $240.00/yr"
});


const BFWApplicationSchema = t.struct({
  name: t.String,
  website: WebsiteRefinement,
  contact_first_name: t.String,
  contact_last_name: t.String,
  contact_email: EmailRefinement,
  job_title: t.String,
  services: t.String,
  is_women_owned: IsWomenOwned,
  bfw_membership_level: MembershipLevel,
  promo_code: PromoCodeRefinement,
});


const formOptions = {
  auto: 'none',
  fields: {
    name: {
      error: 'Please provide the name of your organization',
      attrs: {
        placeholder: 'What is the name of your organization?',
        error: 'this field is required'
      }
    },

    website: {
      error: 'Please provide be a valid website address or url',
      transformer: WebsiteTransformer,
      type: 'text',
      attrs: {
        placeholder: 'What is your web address?'
      }
    },

    contact_first_name: {
      error: 'Please provide your first name',
      attrs: {
        placeholder: 'Your first name',
        error: 'this field is required'
      }
    },

    contact_email: {
      error: 'Please provide a valid email address',
      type: 'email',
      attrs: {
        placeholder: 'Email'
      }
    },

    contact_last_name: {
      error: 'Please provide your last name',
      attrs: {
        placeholder: 'Your last name',
        error: 'this field is required'
      }
    },

    job_title: {
      error: 'Please provide your job title',
      attrs: {
        placeholder: 'What is your job title?',
        error: 'this field is required'
      }
    },



    services: {
      type: 'textarea',
      error: 'This field is required',
      attrs: {
        placeholder: 'Summary of products and/or services'
      }
    },


    is_women_owned: {
      error: 'Please select one of the two',
      factory: t.form.Radio,
      label: 'Are you a woman-owned business (51% + owned by women)?'
    },

    bfw_membership_level: {
      error: 'Please select your membership level',
      factory: t.form.Radio,
      label: 'Which BuyFromWomen membership are you interested in?'
    },

    promo_code: {
      error: 'Please enter a valid promotion code or leave this field blank.',
      attrs: {
        placeholder: 'Promotional code'
      }
    },

  }
};

class BFWApplyToList extends Component {
  state = {
    formOptions: formOptions,
    formValue: {},
    page: 'www_form',
    paypalSuccess: false,
    amount_paypal_received: 0,
    amountBilled: 0,
    paid: false,
    payer_id: '',
    payment_id: '',
    promo_code: ''
  };

  onFormChange = formValue => {
    this.setState({formValue});
  };

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
    }
  }

  componentWillReceiveProps(nextProps) {

  }

  resetForm = () => {
    this.setState({formValue: {
      name: '',
      contact_first_name: '',
      contact_last_name: '',
      job_title: '',
      website: '',
      services: '',
      is_women_owned: null,
      bfw_membership_level: null,
      promo_code: ''
    }});
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const value = this.refs.applyForm.getValue();


    if(!value) {
    }
    else {
      var newValue = Object.assign({}, value);

      if (value.bfw_membership_level == 'BA') {
        newValue.amount_billed = 120;
      } else if (value.bfw_membership_level == 'PR') {
        newValue.amount_billed = 240;
      }

      // update amount_billed with discount
      if (value.promo_code != '' && value.promo_code !== null) {
        let promoCode = value.promo_code.toLowerCase();
        for (let value of PromoCodes) {
          if (value == promoCode) {
            newValue.amount_billed = parseInt(newValue.amount_billed * .5);
            break;
          } else {
            newValue.amount_billed = newValue.amount_billed;
          }
        }
      } else {
        // promo code does not match need to throw error
        newValue.amount_billed = newValue.amount_billed;
      }


      this.setState({ amountBilled: newValue.amount_billed });

      newValue.is_women_owned = (newValue.is_women_owned == 'yes')? true : false;

      this.props.doSaveBFWApplication(newValue);
      this.resetForm();
      window.scrollTo(0,0);

      /*
        Temporarily deactivate paypal payment to go directly to the thank you page.
        To re-activate, update progress graphic to 3 steps and uncomment setState below and delete the following setState.
      */
      //this.setState({page: 'paypal_btn'})
      this.setState({paypalSuccess: true})

    }
  };


  paypalSuccess = (payment) => {
    this.setState({ paypalSuccess: true });
    // Update WWW BFW record
    this.setState(
      {
        amount_paypal_received: this.state.amountBilled,
        paid: true,
        payer_id: payment.payerId,
        payment_id: payment.paymentId
      }
    );

    let applyBFWOrganization_ID = this.props.applyBFWOrganization.id;

    var updateFormValue = {};
    updateFormValue.pk = applyBFWOrganization_ID;
    updateFormValue.amount_paypal_received = this.state.amountBilled;
    updateFormValue.paid = true;
    updateFormValue.payer_id = payment.payerID;
    updateFormValue.payment_id = payment.paymentID;
    updateFormValue.paypal_payment_denied = false;

    this.props.doUpdateBFWApplication(updateFormValue);
  }

  paypalCancelPayment = () => {
    var updateFormValue = {};
    let applyBFWOrganization_ID = this.props.applyBFWOrganization.id;

    updateFormValue.paypal_payment_canceled = true;
    updateFormValue.pk = applyBFWOrganization_ID;

    this.props.doUpdateBFWApplication(updateFormValue);
  }

  paypalError = (error) => {
    var updateFormValue = {};
    let applyBFWOrganization_ID = this.props.applyBFWOrganization.id;

    updateFormValue.paypal_payment_denied = true;
    updateFormValue.pk = applyBFWOrganization_ID;

    this.props.doUpdateBFWApplication(updateFormValue);
  }

  handleProcessPaymentAgain = () => {
    this.setState({ page: 'paypal_btn' });
  }

  render() {
    let { user } = this.props.auth;
    let content = '';
    let buttonCollage = '';
    let collageHeader = '';




    if (this.state.paypalSuccess) {
      collageHeader = <span>
        Thank you for submitting your application!
      </span>;
    } else {
      collageHeader = <span>
        Apply to BuyFromWomen<sup className="bfw-tm">TM</sup>
      </span>;
    }

    // ***************** BEGIN: PAYPAL REST ****************
    const onSuccess = (payment) => {
      this.paypalSuccess(payment);

    }

    const onError = (error) => {
      //console.log('Erroneous payment OR failed to load script!', error);
      //this.paypalError(error);
    }


    const onCancel = (data) => {
      this.paypalCancelPayment();
      //console.log('Cancelled payment!', data);
    }


    // **************** END: PAYPAL REST ********************



    const meta = {
      title: 'WorldWideWomen | Apply to be listed in global women’s directory',
        description: "List your company, organization or service on WorldWideWomen, a global online directory for women. Promote your business and connect with customers.",
      canonical: 'https://worldwidewomen.co/organizations/bfw-apply-to-list',
    }

    let bannerText = <div className="organization-applyBannerText global-banner-text">
      <h2>Apply to list your services on WorldWideWomen!</h2>
      <p className="tag">A powerful resource to connect to women around the world</p>
    </div>;

    if(this.state.page == 'www_form') {
      content = (
        <div className="organization-applyContent">
          <div className="applyToList-steps">
            <img src="/images/bfw_apply_form/apply_steps01.png" />
          </div>
          <div className="applyToList-header">

            {/*
            <h2>Complete the form and submit payment to list your business in our BuyFromWomen<sup className="bfw-tm" style={{ fontSize: '1.0rem' }}>TM</sup> directory</h2>
            */}

            <h2>Complete the application below to list your business in our BuyFromWomen<sup className="bfw-tm" style={{ fontSize: '1.0rem' }}>TM</sup> directory</h2>

          </div>
          <div className="organization-applyContentForm">
            <form onSubmit={this.handleSubmit}>
              <t.form.Form ref="applyForm" onChange={this.onFormChange} value={this.state.formValue} type={BFWApplicationSchema} options={this.state.formOptions} />
              <button className="organizationApply" onClick={this.handleSubmit}>Submit</button>
            </form>
          </div>
      </div>);
    }


    if(this.state.page == 'paypal_btn') {
      bannerText = <div className="organization-applyBannerText global-banner-text">
        <div>Thank you!</div>
          <small>Thank you for applying to be listed on the WorldWideWomen website.<br />
            We will review your application and get back to you shortly.</small>
          <div style={{ 'text-align': 'right', 'font-size': '1.8rem'}}>The WorldWideWomen Team</div>
      </div>;

      content = <div className="organization-applyContent paypal-page">
        <div className="applyToList-steps">
          <img src="/images/bfw_apply_form/apply_steps02.png" />
        </div>
        <div className="applyToList-header">
          <h2>Payment</h2>

          <div className="applyToList-thanksCopy">
            <p>Almost there! Please go ahead and submit your payment through Paypal below. We will then reach out to discuss your listing and coordinate featuring your business on our website, in our newsletter, and across our social media channels.</p>

            <div className="bfwApplyToList-paypalBtnWrapper">
              <PaypalButton
                client={CLIENT}
                env={ENV}
                commit={true}
                currency={'USD'}
                total={this.state.amountBilled}
                onSuccess={onSuccess}
                onError={onError}
                onCancel={onCancel}
              />
            </div>

          </div>
        </div>
      </div>;

    }

    if (this.state.page == 'paypal_error') {
      content = <div className="organization-applyContent">
        <div className="applyToList-steps">
          <img src="/images/bfw_apply_form/apply_steps03.png" />
        </div>
        <div className="applyToList-header">
          <h2>Oops! Payment not accepted.</h2>

          <div className="applyToList-thanksCopy">
            <p>It looks like your payment has not gone through. This could be due to insufficient funds, an incorrect card number, etc. Please check and <Link onClick={this.handleProcessPaymentAgain} to="/bfw-apply-to-list">try to process your payment again</Link>.</p>

            <p>You may also contact <a href="mailTo: imccomish@worldwidewomen.co">Isabel McComish</a> for assistance.</p>
          </div>

        </div>
      </div>;
    }

    if (this.state.paypalSuccess) {
      content = <div className="organization-applyContent">
        <div className="applyToList-steps">
          <img src="/images/bfw_apply_form/apply_steps03.png" />
        </div>
        <div className="applyToList-header">
          <h2>Thank you!</h2>

          <div className="applyToList-thanksCopy">

            {/*

              <p>We are excited that you have decided to list your business in our BuyFromWomen<sup className="bfw-tm">TM</sup> directory. We will be in touch shortly and we look forward to working with you!</p>

            */}


            <p>We are excited that you are interested in listing your business in our BuyFromWomen<sup className="bfw-tm">TM</sup> directory. We will review it and be in touch shortly!</p>

            <p className="applyToList-WWWSig">Welcome from the WorldWideWomen Team</p>

            <div className="bfwThankyou">
              <img src="/images/bfw_apply_form/bfw_thankyou.jpg" />
            </div>
          </div>
        </div>
      </div>;
    }



    return (
      <div>
        <DocumentMeta {...meta} />

        <HomeCollage collageOrganizations={this.props.collageOrganizations}
                     loadCollageOrganizations={this.props.loadCollageOrganizations}
                     browser={this.props.browser}
                     auth={this.props.auth}
                     buttonCollage={buttonCollage}
                     header={collageHeader}
                     />
        <div className="organization-apply">


          <div className="content-wrapper">
            {content}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    doSaveBFWApplication,
    doUpdateBFWApplication,
    pushState,
    loadCollageOrganizations
  }
)(BFWApplyToList);



// WEBPACK FOOTER //
// ./src/containers/BFWApplyToList.jsx